import { ProductLoyaltyRewardsFetchModel } from './types/fetch-model';
import { post } from '../api';

export const fetchLoyaltyRewardsRequest = (params: ProductLoyaltyRewardsFetchModel.ILoyaltyRewardsRequest) =>
  post<ProductLoyaltyRewardsFetchModel.ILoyaltyRewardsResponse>('post-loyalty-rewards', params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
